import React from 'react';
import * as cls from './utilities-layout.module.css';

import { IMG_PATH } from '../../../constants';

const images = [
  {
    alt: 'utilita energy',
    src: 'reviews-utilita-logo.svg',
  },
  {
    alt: 'burgenland energie',
    src: 'burgenland-energie.png',
  },
  {
    alt: 'krone sonne',
    src: 'krone-sonne.svg',
  },
  {
    alt: 'energit',
    src: 'energit.png',
  },
  {
    alt: 'onda piu',
    src: 'onda-piu.png',
  },
  {
    alt: 'sap',
    src: 'sap.png',
  },
  {
    alt: 'octopus-energy',
    src: 'octopus-energy.png',
  },
];

export const UtilitiesLayout = () => (
  <ul className={cls.list}>
    {images.map((img, index) => (
      <li key={index}>
        <img alt={img.alt} src={`${IMG_PATH}/utilities/${img.src}`} />
      </li>
    ))}
  </ul>
);
